import React, { useState, useEffect } from "react";
import { Row, Col, Form, FormControl, Button } from "react-bootstrap";
import withAuth from "../../../services/withAuthProvider";
import withoutAuth from "../../../services/withoutAuthProvider";
import toast from "react-hot-toast";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import Swal from "sweetalert2";

export default function RekeningBankContent() {
  const [dataBank, setDataBank] = useState([]);
  const [bankAccount, setBankAccount] = useState(null);

  const getBank = async () => {
    const response = await withoutAuth.getDataWithoutAuth("/api/bank", {});
    if (response?.status === 200) {
      setDataBank(response.data.data.data);
    } else {
      toast.error(response.data.message, { id: "error-message", duration: 3000 });
    }
  };

  const getBankAccount = async () => {
    const response = await withAuth.getDataWithAuth("/api/account/bank-account", {});
    if (response?.status === 200) {
      const data = response.data.data;
      if (data !== undefined && data.length !== 0) {
        setBankAccount(data);
      }
    } else {
      toast.error(response.data.message, { id: "error-message", duration: 3000 });
    }
  };

  useEffect(() => {
    getBank();
    getBankAccount();
  }, []);

  const validationSchema = Yup.object().shape({
    bank_id: Yup.string().required("Silahkan memilih bank"),
    account_number: Yup.string().required("Silahkan mengisi nomor rekening"),
    account_name: Yup.string().required("Silahkan mengisi nama pemilik rekening"),
    bank_branch_name: Yup.string().required("Silahkan mengisi kantor cabang bank"),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  const onSubmit = async (data) => {
    const confirmed = await Swal.fire({
      title: "Konfirmasi Data Rekening",
      html: "Pastikan data rekening Anda sudah benar.<br/>Setelah disimpan, perubahan hanya dapat dilakukan melalui <strong>admin Caready</strong>.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Ya, Simpan",
      cancelButtonText: "Periksa Kembali",
      confirmButtonColor: "#dc3545",
      cancelButtonColor: "#6c757d",
      reverseButtons: true,
    });
    if (!confirmed.isConfirmed) return;
    const formData = new FormData();
    const found = dataBank.find((bank) => bank.id === parseInt(data.bank_id));
    formData.append("bank_id", data.bank_id);
    formData.append("bank_name", found?.name ?? "");
    formData.append("account_number", data.account_number);
    formData.append("account_name", data.account_name);
    formData.append("bank_branch_name", data.bank_branch_name);

    const loading = toast.loading("Mengirimkan...");
    const response = await withAuth.postDataWithAuth("/api/account/bank-account/update", formData);
    toast.dismiss(loading);
    if (response?.status === 200) {
      setBankAccount(response.data.data);
      toast.success("Rekening bank berhasil disimpan", { id: "success-message", duration: 3000 });
    } else {
      toast.error(response?.data?.message || "Gagal menyimpan rekening bank", {
        id: "error-message",
        duration: 3000,
      });
    }
  };

  const bankName = dataBank.find((b) => b.id === bankAccount?.bank_id)?.name ?? "-";

  return (
    <>
      <h4 className="sub-title">Detail Informasi Bank</h4>
      {bankAccount !== null ? (
        <Row>
          <Col md={6}>
            <div className="form-caready">
              <div className="form-group">
                <label className="form-label">Bank</label>
                <p className="form-control-plaintext">{bankName}</p>
              </div>
              <div className="form-group">
                <label className="form-label">No Rekening</label>
                <p className="form-control-plaintext">{bankAccount?.account_number ?? "-"}</p>
              </div>
              <div className="form-group">
                <label className="form-label">Atas Nama</label>
                <p className="form-control-plaintext">{bankAccount?.account_name ?? "-"}</p>
              </div>
              <div className="form-group">
                <label className="form-label">Kantor Cabang</label>
                <p className="form-control-plaintext">{bankAccount?.bank_branch_name ?? "-"}</p>
              </div>
            </div>
          </Col>
        </Row>
      ) : (
        <Row>
          <Col md={6}>
            <Form onSubmit={handleSubmit(onSubmit)} className="form-caready">
              <div className="form-group">
                <label className="form-label">
                  Bank <span className="text-danger">*</span>
                </label>
                <FormControl as="select" {...register("bank_id")} isInvalid={!!errors.bank_id}>
                  <option value="">Pilih Bank</option>
                  {dataBank.map((bank) => (
                    <option key={bank.id} value={bank.id}>
                      {bank.name}
                    </option>
                  ))}
                </FormControl>
                {errors.bank_id ? (
                  <div className="invalid-feedback d-block">{errors.bank_id.message}</div>
                ) : null}
              </div>
              <div className="form-group">
                <label className="form-label">
                  No Rekening <span className="text-danger">*</span>
                </label>
                <FormControl
                  type="text"
                  {...register("account_number")}
                  isInvalid={!!errors.account_number}
                  placeholder="Masukkan nomor rekening"
                />
                {errors.account_number ? (
                  <div className="invalid-feedback d-block">{errors.account_number.message}</div>
                ) : null}
              </div>
              <div className="form-group">
                <label className="form-label">
                  Atas Nama <span className="text-danger">*</span>
                </label>
                <FormControl
                  type="text"
                  {...register("account_name")}
                  isInvalid={!!errors.account_name}
                  placeholder="Masukkan nama pemilik rekening"
                />
                {errors.account_name ? (
                  <div className="invalid-feedback d-block">{errors.account_name.message}</div>
                ) : null}
              </div>
              <div className="form-group">
                <label className="form-label">
                  Kantor Cabang <span className="text-danger">*</span>
                </label>
                <FormControl
                  type="text"
                  {...register("bank_branch_name")}
                  isInvalid={!!errors.bank_branch_name}
                  placeholder="Masukkan kantor cabang bank"
                />
                {errors.bank_branch_name ? (
                  <div className="invalid-feedback d-block">{errors.bank_branch_name.message}</div>
                ) : null}
              </div>
              <Button type="submit" className="btn-caready-primary">
                Simpan
              </Button>
            </Form>
          </Col>
        </Row>
      )}
    </>
  );
}
